import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowGetSftpFileBlockConfigSchema = z.object({
    path: z.string(),
    server: z.string(),
});
export const FlowGetSftpFileBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.GetSftpFile),
    config: FlowGetSftpFileBlockConfigSchema,
});
//# sourceMappingURL=config.js.map